// JSS
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
import jss from "jss";
import camelCase from "jss-plugin-camel-case";
import expand from "jss-plugin-expand";
import template from "jss-plugin-template";
import nested from "jss-plugin-nested";
import defaultUnit from "jss-plugin-default-unit";
jss.use(template(), nested(), camelCase(), defaultUnit(), expand());
